import REDCRM_PAGE from "@/redcrm/routes/redcrm-page";
export default [
  {
    path: REDCRM_PAGE.REJECT_ACCEPT_EMAIL,
    name: "RejectAcceptEmail",
    // beforeEnter: isSigned,
    component: () => import("@/redcrm/views/customer/customers/RejectAcceptEmail.vue"),
  },
  {
    path: REDCRM_PAGE.CAMPAIGN_TRACKING_WITH_LONG_KEY,
    name: "CampaignTrackingWithLongKey",
    component: () => import("@/redcrm/views/campaign/CampaignTrackingWithLongKey.vue"),
  },
  {
    path: REDCRM_PAGE.CAMPAIGN_TRACKING_WITH_SHORT_KEY,
    name: "CampaignTrackingWithShortKey",
    component: () => import("@/redcrm/views/campaign/CampaignTrackingWithShortKey.vue"),
  },
  
  
  {
    path: REDCRM_PAGE.KAKAO_LOGOUT,
    name: "KakaoLogout",
    component:()=> import("@/redcrm/views/customer/simple-signup/KakaoLogout.vue"),
  },
  
  
 
  {
    path: REDCRM_PAGE.CUSTOMER_SIGNUP,
    name: "CustomerSignup",
    component:()=> import("@/redcrm/views/customer/customer-signup/CustomerSignup.vue"),
  },

  {
    path: REDCRM_PAGE.TERMS_DETAIL,
    name: "TermsDetail",
    component:()=> import("@/redcrm/views/terms/TermsDetail.vue"),
    props:true
  },
  
  {
    path: REDCRM_PAGE.IDENTIFY_RESPONSE,
    name: "IdentifyResponse",
    component:()=> import("@/redcrm/components/customer/customer-identify/RcIdentifyResponse.vue"),
  },
  {
    path: REDCRM_PAGE.IDENTIFY_REQUEST,
    name: "IdentifyRequest",
    component:()=> import("@/redcrm/components/customer/customer-identify/RcIdentifyRequest.vue"),
  },
  

  {
    path: REDCRM_PAGE.OFFER_CONFIRM,
    name: "couponConfirm",
    // beforeEnter: isSigned,
    component: () => import("@/redcrm/components/coupon/RcCouponConfirm.vue"),
  },
  {
    path: REDCRM_PAGE.OFFER_CONFIRM_SHORT,
    name: "couponConfirm",
    // beforeEnter: isSigned,
    component: () => import("@/redcrm/components/coupon/RcCouponConfirm.vue"),
  },

  {
    path: REDCRM_PAGE.COUPON,
    name: "CouponList",
    component: () =>
      import("@/redcrm/views/coupon/CouponList.vue"),
    meta: {
      title: "coupon.lbl.coupon",
      parent: "Home",
      checkAuth: true,
      groupId: "COUPON",
    },
  },

  {
    path: REDCRM_PAGE.COUPON_DETAIL,
    name: "CouponDetail",
    props: true,
    component: () =>
      import("@/redcrm/views/coupon/CouponDetail.vue"),
    meta: {
      title: "coupon.lbl.coupon_detail",
      checkAuth: true,
      parent: "CouponList",
      groupId: "COUPON",
    },
  },



];
